import React from "react";
import { styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";
import "../remediationDocumentStyles.css";
import { Button } from "@mui/material";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: 0,
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    marginTop: 0,
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 4,
      borderColor: "#74b44a",
      boxShadow: 0,
      outline: 0,
    },
  },
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#ED1B23",
  backgroundColor: "#FFF0F0",
  borderColor: "#ED1B23",
  padding: "7px 15px",
  textTransform: "capitalize",
  "&:hover": {
    color: "white",
    backgroundColor: "#ED1B23",
  },
}));

export default function MainFilters(props) {
  const {
    data,
    mainFilters,
    approveStatus,
    setMainFilters,
    hasUnapprovedItems,
    setShowConfirmation,
  } = props;

  const handleChange = (event) => {
    setMainFilters(event.target.value);
  };
  return (
    <div className="finterInnerCnt">
      <FormControl sx={{ margin: 1 }}>
        <InputLabel
          htmlFor="demo-customized-select-native"
          style={{ display: "none" }}
        ></InputLabel>
        <NativeSelect
          id="demo-customized-select-native"
          value={mainFilters}
          onChange={handleChange}
          input={<BootstrapInput />}
        >
          {data?.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </NativeSelect>
      </FormControl>

      <ColorButton
        variant="outlined"
        disabled={approveStatus || !hasUnapprovedItems}
        sx={{ margin: 1 }}
        onClick={() => setShowConfirmation({ all: true })}
      >
        Delete All Unapproved
      </ColorButton>
    </div>
  );
}
